module.exports = __webpack_public_path__ + "static/2-da5750b15b30a2025d5f738fb46f030b.svg";